import React, { useRef, useEffect, useState } from 'react';

const ScratchCard = ({ 
  width = 300, 
  height = 400, 
  overlayColor = '#111111', 
  brushSize = 40, 
  onComplete, 
  children,
  finishPercent = 50,
  type = 'Elite Golden Card (Standard)'
}) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Create Gradient based on type
    let gradient;
    if (type.includes('Golden')) {
      gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#d4af37');
      gradient.addColorStop(0.5, '#fcf6ba');
      gradient.addColorStop(1, '#b8860b');
    } else if (type.includes('Silver')) {
      gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#757f9a');
      gradient.addColorStop(0.5, '#d7dde8');
      gradient.addColorStop(1, '#757f9a');
    } else if (type.includes('Diamond')) {
      gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#e0eafc');
      gradient.addColorStop(0.5, '#cfdef3');
      gradient.addColorStop(1, '#e0eafc');
    } else if (type.includes('Royal')) {
      gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#2c3e50');
      gradient.addColorStop(0.5, '#4ca1af');
      gradient.addColorStop(1, '#2c3e50');
    } else {
      gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#111111');
      gradient.addColorStop(1, '#333333');
    }

    // Draw overlay
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    // Add Luxury Texture
    ctx.globalAlpha = 0.1;
    for (let i = 0; i < 2000; i++) {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(Math.random() * width, Math.random() * height, 1, 1);
    }
    ctx.globalAlpha = 1.0;

    // Add Pattern/Logo
    ctx.strokeStyle = 'rgba(255,255,255,0.1)';
    ctx.lineWidth = 1;
    for (let i = 0; i < width; i += 20) {
      ctx.beginPath();
      ctx.moveTo(i, 0);
      ctx.lineTo(i, height);
      ctx.stroke();
    }

    // Add text to overlay
    ctx.fillStyle = type.includes('Silver') || type.includes('Diamond') ? '#000000' : '#ffffff';
    ctx.font = 'bold 20px Outfit';
    ctx.textAlign = 'center';
    ctx.letterSpacing = '4px';
    ctx.fillText('SCRATCH TO REVEAL', width / 2, height / 2);
    
    ctx.font = 'italic 10px Outfit';
    ctx.fillText('EXCLUSIVE PRIVILEGE', width / 2, height / 2 + 30);
  }, [width, height, type]);

  const getPos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return {
      x: clientX - rect.left,
      y: clientY - rect.top
    };
  };

  const scratch = (x, y) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath();
    ctx.arc(x, y, brushSize, 0, Math.PI * 2);
    ctx.fill();

    checkCompletion();
  };

  const checkCompletion = () => {
    if (completed) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, width, height);
    const pixels = imageData.data;
    let transparentPixels = 0;

    for (let i = 3; i < pixels.length; i += 4) {
      if (pixels[i] === 0) {
        transparentPixels++;
      }
    }

    const percent = (transparentPixels / (width * height)) * 100;
    if (percent > finishPercent) {
      setCompleted(true);
      if (onComplete) onComplete();
    }
  };

  const handleMouseDown = (e) => {
    setIsDrawing(true);
    const pos = getPos(e);
    scratch(pos.x, pos.y);
  };

  const handleMouseMove = (e) => {
    if (!isDrawing || completed) return;
    const pos = getPos(e);
    scratch(pos.x, pos.y);
  };

  const handleMouseUp = () => {
    setIsDrawing(false);
  };

  return (
    <div className="relative overflow-hidden rounded-3xl shadow-2xl border border-black/[0.05]" style={{ width, height }}>
      {/* The Reward Content (Behind) */}
      <div className="absolute inset-0 flex flex-col items-center justify-center bg-white p-6 text-center">
        {children}
      </div>

      {/* The Scratch Layer (Front) */}
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        className={`absolute top-0 left-0 z-10 touch-none transition-opacity duration-1000 ${completed ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleMouseDown}
        onTouchMove={handleMouseMove}
        onTouchEnd={handleMouseUp}
      />
    </div>
  );
};

export default ScratchCard;
